<div class="titration-rechner-popup {{partnerName}}">
    <ng-container [ngSwitch]="partnerName">
        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
            <p class="big-text">Um die Nutzung des Angebots statistisch zu erfassen, möchten wir Sie bitten, uns Angaben zu Ihrer Fachrichtung und Ihrem Bundesland zu machen. Wir bedanken uns herzlich für Ihre Unterstützung.</p>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <p class="big-text">Um die Nutzung des Copeia-Angebots statistisch zu erfassen, möchten wir Sie bitten, uns Angaben zu Ihrer Fachrichtung und Ihrem Bundesland zu machen. Wir bedanken uns herzlich für Ihre Unterstützung.</p>
        </ng-container>
    </ng-container>    

    <div class="form-row">
        <label>Fachrichtung:</label>
        <select class="form-control" [(ngModel)]="FachrichtungVal">
            <option value="">Please Choose</option>
            <ng-container *ngFor="let item of FachrichtungList">
                <option [value]="item">{{item}}</option>
            </ng-container>
        </select>
        <input *ngIf="showFachrichtungInput" type="text" class="form-control mt-3" [(ngModel)]="FachrichtungInput" placeholder="At least 3 characters required" />
    </div>
    <div class="form-row">
        <label>Bundesland:</label>
        <select class="form-control" [(ngModel)]="BundeslandVal">
            <option value="">Please Choose</option>
            <ng-container *ngFor="let item of BundeslandList">
                <option [value]="item">{{item}}</option>
            </ng-container>
        </select>
        <input *ngIf="showBundeslandInput" type="text" class="form-control mt-3" [(ngModel)]="BundeslandInput" placeholder="At least 3 characters required" />
    </div>

    <div class="button-block">
        <div class="popup-warning">
            <ng-container *ngIf="showAlertInfo">
                <img src="/Info Revert.svg" alt="Info Revert" />
                <span>Bitte beantworten Sie die Fragen, um fortzufahren</span>
            </ng-container>
        </div>
        <div class="standard-btn btn-blue" (click)="submitForm()">Weiter</div>
    </div>
    <hr />
    <div class="footer-link">
        <ul>
            <li>
                <ng-container [ngSwitch]="partnerName">
                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
                        <a href="/dosis-eq/tilray/datenschutz">Datenschutz</a>
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                        <a href="/dosis-eq/hormosan/datenschutz">Datenschutz</a>
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                        <a href="/dosis-eq/420pharma/datenschutz">Datenschutz</a>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <a href="/datenschutz">Datenschutz</a>
                    </ng-container>
                </ng-container>
            </li>
            <li>
                <a href="mailto:info@copeia.de" target="_blank">Kontakt</a>
            </li>
        </ul>
        <div class="text-right">
            <small>© Copeia GmbH, {{fullYear}}</small>
        </div>
    </div>
</div>
